import React, { Component } from "react";
import { Table, Accordion } from "semantic-ui-react";
import _ from "lodash";

class Counties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  componentDidMount() {}

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const areaNodes = [];
    if (this.props.node !== undefined) {
      const zipCodes = _.get(this.props.node, "area[0].zipCodes");
      if (zipCodes !== undefined) {
        _.forEach(zipCodes, (zipCode, index) => {
          areaNodes.push(
            <Table.Row key={`zipcode_row_${index}`}>
              <Table.Cell width={3}>
                <span className="text-bold">City</span>
              </Table.Cell>
              <Table.Cell width={6}>{_.get(zipCode, "city[0]", "")}</Table.Cell>
              <Table.Cell width={3}>
                <span className="text-bold">County</span>
              </Table.Cell>
              <Table.Cell width={4}>
                {_.get(zipCode, "county[0]", "")}
              </Table.Cell>
            </Table.Row>
          );
        });
      }
    }

    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`CountiesTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Counties Subject Has Lived In
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`CountiesBody`}
          active={this.state.activeIndex === 0}
        >
          <Table width={2} className={"table-no-border table-custom-strip"}>
            <Table.Body>{areaNodes}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default Counties;



// WEBPACK FOOTER //
// ./src/components/reports/Counties.js